module.exports = __webpack_public_path__ + "static/media/3DPPA7.f0f075c8.jpg";